import React, { useState } from 'react';
import { X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <footer className="bg-gray-900 text-gray-400 py-12 px-4" data-id="element-304">
      <div className="max-w-lg md:max-w-4xl mx-auto text-center" data-id="element-305">
        <div className="text-2xl font-black text-white mb-6" data-id="element-306">
          🥦 NUTRIPEQUES
        </div>

        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm" data-id="element-307">
          <button onClick={() => setModalContent('privacy')} className="hover:text-white transition-colors" data-id="element-308">
            Política de Privacidad
          </button>
          <button onClick={() => setModalContent('terms')} className="hover:text-white transition-colors" data-id="element-309">
            Términos y Condiciones
          </button>
        </div>

        <p className="text-xs" data-id="element-310">
          © 2026 NutriPeques. Todos los derechos reservados.
        </p>
        <p className="text-xs mt-4 opacity-50 max-w-2xl mx-auto" data-id="element-311">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>

      {/* Modal */}
      {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" data-id="element-312">
          <div className="bg-white rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden shadow-2xl" data-id="element-313">
            <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-314">
              <h3 className="text-lg font-bold text-gray-900" data-id="element-315">
                {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
              </h3>
              <button onClick={() => setModalContent(null)} className="p-2 text-gray-500 hover:bg-gray-100 rounded-full transition-colors" data-id="element-316">
                <X className="w-5 h-5" data-id="element-317" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto text-sm text-gray-600 space-y-4" data-id="element-318">
              {modalContent === 'privacy' ? <>
                  <p data-id="element-319">
                    <strong data-id="element-320">1. Recopilación de Información</strong>
                    <br data-id="element-321" />
                    Recopilamos información cuando te registras en nuestro
                    sitio, realizas una compra o te suscribes a nuestro boletín.
                    La información recopilada incluye tu nombre y correo
                    electrónico.
                  </p>
                  <p data-id="element-322">
                    <strong data-id="element-323">2. Uso de la Información</strong>
                    <br data-id="element-324" />
                    Cualquier información que recopilemos de ti puede ser
                    utilizada para: personalizar tu experiencia, mejorar nuestro
                    sitio web, mejorar el servicio al cliente y procesar
                    transacciones.
                  </p>
                  <p data-id="element-325">
                    <strong data-id="element-326">3. Privacidad del Comercio Electrónico</strong>
                    <br data-id="element-327" />
                    Somos los únicos propietarios de la información recopilada
                    en este sitio. Tu información personal no será vendida,
                    intercambiada, transferida o dada a ninguna otra empresa por
                    ningún motivo, sin tu consentimiento, excepto para el
                    propósito expreso de entregar el producto o servicio
                    adquirido.
                  </p>
                  <p data-id="element-328">
                    <strong data-id="element-329">4. Divulgación a Terceros</strong>
                    <br data-id="element-330" />
                    No vendemos, intercambiamos ni transferimos de ninguna otra
                    manera a terceros tu información de identificación personal.
                    Esto no incluye a terceros de confianza que nos asisten en
                    la operación de nuestro sitio web o en la realización de
                    nuestro negocio, siempre que esas partes acuerden mantener
                    esta información confidencial.
                  </p>
                  <p data-id="element-331">
                    <strong data-id="element-332">5. Uso de Cookies</strong>
                    <br data-id="element-333" />
                    Nuestras cookies mejoran el acceso a nuestro sitio e
                    identifican a los visitantes frecuentes. Además, nuestras
                    cookies mejoran la experiencia del usuario rastreando y
                    apuntando a sus intereses. Sin embargo, este uso de cookies
                    no está vinculado de ninguna manera a ninguna información de
                    identificación personal en nuestro sitio.
                  </p>
                  <p data-id="element-334">
                    <strong data-id="element-335">6. Consentimiento</strong>
                    <br data-id="element-336" />
                    Al utilizar nuestro sitio, aceptas nuestra política de
                    privacidad.
                  </p>
                </> : <>
                  <p data-id="element-337">
                    <strong data-id="element-338">1. Aceptación de los Términos</strong>
                    <br data-id="element-339" />
                    Al acceder y utilizar este producto digital (NutriPeques),
                    aceptas estar sujeto a estos Términos y Condiciones. Si no
                    estás de acuerdo con alguna parte de los términos, no podrás
                    acceder al producto.
                  </p>
                  <p data-id="element-340">
                    <strong data-id="element-341">2. Producto Digital</strong>
                    <br data-id="element-342" />
                    NutriPeques es un producto digital (eBook/Guía). El acceso
                    se proporciona inmediatamente después de la compra exitosa.
                    No se enviará ningún producto físico.
                  </p>
                  <p data-id="element-343">
                    <strong data-id="element-344">3. Política de Reembolso</strong>
                    <br data-id="element-345" />
                    Ofrecemos una garantía de devolución de dinero de 7 días. Si
                    no estás satisfecho con el producto, puedes solicitar un
                    reembolso completo dentro de los 7 días posteriores a la
                    compra. Pasados los 7 días, no se emitirán reembolsos bajo
                    ninguna circunstancia.
                  </p>
                  <p data-id="element-346">
                    <strong data-id="element-347">4. Propiedad Intelectual</strong>
                    <br data-id="element-348" />
                    Todo el contenido incluido en NutriPeques (textos, gráficos,
                    logotipos, imágenes, compilaciones de datos y software) es
                    propiedad de NutriPeques y está protegido por las leyes de
                    derechos de autor. No puedes reproducir, distribuir,
                    modificar, crear trabajos derivados, exhibir públicamente,
                    ejecutar públicamente, republicar, descargar, almacenar o
                    transmitir ninguno de los materiales de nuestro producto sin
                    el consentimiento previo por escrito.
                  </p>
                  <p data-id="element-349">
                    <strong data-id="element-350">5. Limitación de Responsabilidad</strong>
                    <br data-id="element-351" />
                    La información proporcionada en NutriPeques es solo para
                    fines educativos e informativos. No sustituye el consejo
                    médico profesional, diagnóstico o tratamiento. Siempre busca
                    el consejo de tu médico, pediatra u otro proveedor de salud
                    calificado con cualquier pregunta que puedas tener sobre una
                    condición médica o la alimentación de tu hijo.
                  </p>
                  <p data-id="element-352">
                    <strong data-id="element-353">6. Modificaciones</strong>
                    <br data-id="element-354" />
                    Nos reservamos el derecho de modificar o reemplazar estos
                    Términos en cualquier momento. Es tu responsabilidad revisar
                    estos Términos periódicamente para ver si hay cambios.
                  </p>
                </>}
            </div>
            <div className="p-4 border-t border-gray-100 bg-gray-50 text-right" data-id="element-355">
              <button onClick={() => setModalContent(null)} className="px-6 py-2 bg-gray-900 text-white rounded-xl font-bold hover:bg-gray-800 transition-colors" data-id="element-356">
                Cerrar
              </button>
            </div>
          </div>
        </div>}
    </footer>;
}